import React from 'react';
import './styles/App.css';
import { useAuth0 } from '@auth0/auth0-react';
import { ToastContainer } from 'react-toastify';
import Login from './components/Login';
import 'react-toastify/dist/ReactToastify.css';
import Logout from './components/Logout';
import SplashScreen from './components/SplashScreen';

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) return <SplashScreen />;

  return (
    <>
      <Logout />
      <Login />
      <ToastContainer
        position="top-right"
        theme="light"
        hideProgressBar
        pauseOnHover
        autoClose={4000}
        draggable
      />
    </>
  );
}

export default App;
